import { render } from "./Suore.vue?vue&type=template&id=91144008"
import script from "./Suore.vue?vue&type=script&lang=js"
export * from "./Suore.vue?vue&type=script&lang=js"

import "./Suore.vue?vue&type=style&index=0&id=91144008&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__